import { getAdminErrorMessage } from '../adminErrorModel'

export const getCleanupResultMessage = (deletedCount: number): string => {
  if (deletedCount === 0) {
    return 'No orphaned route events were found. Nothing was deleted.'
  }
  if (deletedCount === 1) {
    return 'Deleted 1 orphaned route event.'
  }
  return `Deleted ${deletedCount} orphaned route events.`
}

export const getCleanupErrorMessage = (error: unknown): string => {
  return getAdminErrorMessage(error, 'Failed to clean up orphaned route events. Please try again.')
}
